"use client";

import { AppImage } from "@/src/components/NextImage";
import React from "react";
import { cn } from "utils";

export interface GhostPreviewImageProps {
  /** Public asset path, e.g. /assets/images/portfolio/empty/ghost-header-h5.webp */
  src: string;
  width: number;
  height: number;
  alt?: string;
  className?: string;
  /** Optional test id suffix */
  testId?: string;
}

/**
 * Non-interactive ghost preview slice exported from Figma.
 */
export const GhostPreviewImage: React.FC<GhostPreviewImageProps> = ({
  src,
  width,
  height,
  alt = "",
  className,
  testId,
}) => {
  return (
    <div
      className={cn("pointer-events-none w-full select-none", className)}
      data-testid={testId ? `portfolio-ghost-image-${testId}` : undefined}
      aria-hidden
    >
      <AppImage
        src={src}
        alt={alt}
        width={width}
        height={height}
        className="h-auto w-full"
        draggable={false}
      />
    </div>
  );
};
